/* eslint-disable */
/* This file is generated by "npm run i18n:compile". Do not edit manually. */
export const enUSMessages = {
  'admin.roles.groups.addButton': 'Create group',
  'admin.roles.groups.create.confirm': 'Create group',
  'admin.roles.groups.create.description': 'Add a new group to manage access.',
  'admin.roles.groups.create.name.label': 'Group name',
  'admin.roles.groups.create.name.placeholder': 'e.g. engineering',
  'admin.roles.groups.create.name.required': 'Group name is required',
  'admin.roles.groups.create.title': 'Create Group',
  'admin.roles.groups.delete.body': 'Are you sure you want to delete {group}? This action cannot be undone.',
  'admin.roles.groups.delete.confirm': 'Delete group',
  'admin.roles.groups.delete.title': 'Delete group',
  'admin.roles.groups.empty': 'No groups found',
  'admin.roles.groups.flyout.members.title': 'Members',
  'admin.roles.groups.flyout.roles.add': 'Add roles',
  'admin.roles.groups.flyout.roles.placeholder': 'Select roles',
  'admin.roles.groups.flyout.roles.showAll': 'Show all',
  'admin.roles.groups.flyout.roles.title': 'Roles',
  'admin.roles.groups.id.missing': 'Group unavailable',
  'admin.roles.groups.loadError': 'Could not load groups',
  'admin.roles.groups.manageRoles.empty': 'No roles assigned',
  'admin.roles.groups.manageRoles.loadError': 'Failed to load roles',
  'admin.roles.groups.manageRoles.loading': 'Loading roles...',
  'admin.roles.groups.manageRoles.remove.label': 'Remove role',
  'admin.roles.groups.manageRoles.search.empty': 'No roles found',
  'admin.roles.groups.manageRoles.search.placeholder': 'Search roles',
  'admin.roles.groups.manageRoles.selectedLabel': 'roles selected',
  'admin.roles.groups.members.add.confirm': 'Add users',
  'admin.roles.groups.members.add.empty': 'No users match your search',
  'admin.roles.groups.members.add.placeholder': 'Select users to add',
  'admin.roles.groups.members.add.search': 'Search users',
  'admin.roles.groups.members.add.searching': 'Searching users...',
  'admin.roles.groups.members.add.selectedLabel': 'users selected',
  'admin.roles.groups.members.add.title': 'Add users',
  'admin.roles.groups.members.count': '{count, plural, one {{count} member} other {{count} members}}',
  'admin.roles.groups.members.empty': 'No members found',
  'admin.roles.groups.members.loadError': 'Failed to load members',
  'admin.roles.groups.members.loading': 'Loading members...',
  'admin.roles.groups.members.remove.label': 'Remove user',
  'admin.roles.groups.members.search.placeholder': 'Search members',
  'admin.roles.groups.name.fallback': 'Unnamed group',
  'admin.roles.groups.roles.empty': 'No roles',
  'admin.roles.groups.search.placeholder': 'Search groups',
  'admin.roles.groups.table.actions': 'Actions',
  'admin.roles.groups.table.actions.delete': 'Delete group',
  'admin.roles.groups.table.members': 'Members',
  'admin.roles.groups.table.name': 'Group',
  'admin.roles.groups.table.roles': 'Roles',
  'admin.roles.groups.toasts.create.error': 'Failed to create group',
  'admin.roles.groups.toasts.create.loading': 'Creating group...',
  'admin.roles.groups.toasts.create.success': 'Group created successfully',
  'admin.roles.groups.toasts.delete.error': 'Failed to delete group',
  'admin.roles.groups.toasts.delete.loading': 'Deleting group...',
  'admin.roles.groups.toasts.delete.success': 'Group deleted successfully',
  'admin.roles.groups.toasts.members.add.error': 'Failed to add {count, plural, one {member} other {members}}',
  'admin.roles.groups.toasts.members.add.loading': 'Adding {count, plural, one {member} other {members}}...',
  'admin.roles.groups.toasts.members.add.success': 'Added {count, plural, one {member} other {members}}',
  'admin.roles.groups.toasts.members.remove.error': 'Failed to remove {count, plural, one {member} other {members}}',
  'admin.roles.groups.toasts.members.remove.loading': 'Removing {count, plural, one {member} other {members}}...',
  'admin.roles.groups.toasts.members.remove.success': 'Removed {count, plural, one {member} other {members}}',
  'admin.roles.groups.toasts.roles.error': 'Failed to update roles',
  'admin.roles.groups.toasts.roles.loading': 'Updating roles...',
  'admin.roles.groups.toasts.roles.success': 'Roles updated successfully',
  'admin.roles.header.subtitle': 'Manage access for users and roles',
  'admin.roles.header.title': 'Roles & Permissions',
  'admin.roles.roles.composite.empty': 'No composite roles found',
  'admin.roles.roles.composite.false': 'False',
  'admin.roles.roles.composite.loading': 'Loading composite roles...',
  'admin.roles.roles.composite.tooltip.title': 'Composite roles',
  'admin.roles.roles.composite.true': 'True',
  'admin.roles.roles.empty': 'No roles found',
  'admin.roles.roles.hidden': 'Click to view hidden roles',
  'admin.roles.roles.loadError': 'Could not load roles',
  'admin.roles.roles.name.fallback': 'Unnamed role',
  'admin.roles.roles.search.placeholder': 'Search roles',
  'admin.roles.roles.table.composite': 'Composite',
  'admin.roles.roles.table.description': 'Description',
  'admin.roles.roles.table.role': 'Role',
  'admin.roles.roles.toasts.assign.error': 'Failed to assign roles',
  'admin.roles.roles.toasts.assign.loading': 'Assigning roles to {count, plural, one {user} other {{count} users}}...',
  'admin.roles.roles.toasts.assign.success': 'Assigned roles to {succeeded}/{total} users',
  'admin.roles.roles.toasts.remove.error': 'Failed to remove roles',
  'admin.roles.roles.toasts.remove.loading': 'Updating {count, plural, one {user} other {{count} users}}...',
  'admin.roles.roles.toasts.remove.success': 'Updated {succeeded}/{total} users',
  'admin.roles.roles.toasts.update.error': 'Failed to update role',
  'admin.roles.roles.toasts.update.loading': 'Updating role...',
  'admin.roles.roles.toasts.update.success': 'Role updated successfully',
  'admin.roles.tabs.groups': 'Groups',
  'admin.roles.tabs.roles': 'Roles',
  'admin.roles.tabs.users': 'Users',
  'admin.roles.users.activity.empty': 'No activity',
  'admin.roles.users.assignButton': 'Assign roles',
  'admin.roles.users.create.button': 'Create user',
  'admin.roles.users.create.confirm': 'Create user',
  'admin.roles.users.create.description': 'Add a new user. They will receive an account in your organization.',
  'admin.roles.users.create.email.invalid': 'Enter a valid email address',
  'admin.roles.users.create.email.label': 'Email',
  'admin.roles.users.create.email.placeholder': 'user@example.com',
  'admin.roles.users.create.email.required': 'Email is required',
  'admin.roles.users.create.enabled.hint': 'Allow this user to sign in.',
  'admin.roles.users.create.enabled.label': 'Enabled',
  'admin.roles.users.create.firstName.label': 'First name',
  'admin.roles.users.create.firstName.placeholder': 'John',
  'admin.roles.users.create.firstName.required': 'First name is required',
  'admin.roles.users.create.lastName.label': 'Last name',
  'admin.roles.users.create.lastName.placeholder': 'Smith',
  'admin.roles.users.create.lastName.required': 'Last name is required',
  'admin.roles.users.create.password.hint': 'Leave blank to set it later — you will need to share it with the user yourself.',
  'admin.roles.users.create.password.label': 'Password',
  'admin.roles.users.create.password.placeholder': 'Optional',
  'admin.roles.users.create.sendInvite.deliveryFailed': 'The invite email could not be sent, so the user was not created. Turn off "Send invite email" and set a password instead, or retry once email is working.',
  'admin.roles.users.create.sendInvite.hint': 'Email a single-use link so they set their own password.',
  'admin.roles.users.create.sendInvite.label': 'Send invite email',
  'admin.roles.users.create.temporaryPassword.hint': 'Require the user to change their password on first sign-in.',
  'admin.roles.users.create.temporaryPassword.label': 'Temporary password',
  'admin.roles.users.create.title': 'Create user',
  'admin.roles.users.disabled': 'Disabled',
  'admin.roles.users.empty.default': 'No users found',
  'admin.roles.users.empty.search': 'No users match your search',
  'admin.roles.users.flyout.direct.title': 'Directly Assigned',
  'admin.roles.users.flyout.groups.add': 'Add groups',
  'admin.roles.users.flyout.groups.loading': 'Loading groups...',
  'admin.roles.users.flyout.groups.placeholder': 'Select groups',
  'admin.roles.users.flyout.groups.remove.label': 'Remove from group',
  'admin.roles.users.flyout.groups.roles.empty': 'No roles from this group',
  'admin.roles.users.flyout.groups.roles.loadError': 'Failed to load group roles',
  'admin.roles.users.flyout.groups.searchPlaceholder': 'Search groups...',
  'admin.roles.users.flyout.groups.selectedLabel': 'groups',
  'admin.roles.users.flyout.groups.selectEmpty': 'No groups found',
  'admin.roles.users.flyout.groups.selectTitle': 'Groups',
  'admin.roles.users.flyout.groups.title': 'Groups',
  'admin.roles.users.flyout.roles.add': 'Add roles',
  'admin.roles.users.flyout.roles.placeholder': 'Select roles',
  'admin.roles.users.flyout.roles.remove.label': 'Remove role',
  'admin.roles.users.flyout.search.noMatches': 'No roles match your search',
  'admin.roles.users.flyout.search.placeholder': 'Search roles...',
  'admin.roles.users.groups.empty': 'No groups',
  'admin.roles.users.groups.loadError': 'Failed to load groups',
  'admin.roles.users.loadError': 'Could not load users',
  'admin.roles.users.removeButton': 'Remove roles',
  'admin.roles.users.roles.empty': 'No roles',
  'admin.roles.users.roles.inherited': 'Inherited from a group',
  'admin.roles.users.roles.loadError': 'Failed to load',
  'admin.roles.users.search.placeholder': 'Search users',
  'admin.roles.users.selected.count': '{count, plural, one {{count} user selected} other {{count} users selected}}',
  'admin.roles.users.selectRoles.error': 'Select at least one role',
  'admin.roles.users.selectRoles.loading': 'Loading roles...',
  'admin.roles.users.selectRoles.placeholder': 'Select roles',
  'admin.roles.users.selectRoles.searchPlaceholder': 'Search roles',
  'admin.roles.users.selectRoles.title': 'Roles',
  'admin.roles.users.table.activity': 'Activity',
  'admin.roles.users.table.groups': 'Groups',
  'admin.roles.users.table.modifiedAt': 'Last Modified',
  'admin.roles.users.table.roles': 'Roles',
  'admin.roles.users.table.user': 'User',
  'admin.roles.users.toasts.create.error': 'Failed to create user',
  'admin.roles.users.toasts.create.loading': 'Creating user...',
  'admin.roles.users.toasts.create.success': 'User created successfully',
  'admin.roles.users.toasts.update.error': 'Failed to update user status',
  'admin.roles.users.toasts.update.success': 'User status successfully updated',
  'app-bar.user-menu.backgroundJobs': 'Background job monitor',
  'app-bar.user-menu.businessDashboard': 'Business dashboard',
  'app-bar.user-menu.logout': 'Log out',
  'app-bar.user-menu.openDocumentation': 'Documentation',
  'app-bar.user-menu.usage': 'Usage',
  'auth.password.requirement.lowercase': 'At least one lowercase letter',
  'auth.password.requirement.minLength': 'At least {min} characters',
  'auth.password.requirement.number': 'At least one number',
  'auth.password.requirement.special': 'At least one special character',
  'auth.password.requirement.uppercase': 'At least one uppercase letter',
  'code-remedy.mass-remediate.apply-fixes.error': 'Failed to apply fixes to {count, plural, one {object} other {# objects}}: {error}',
  'code-remedy.mass-remediate.apply-fixes.failed': 'Failed to apply fixes to {count, plural, one {object} other {# objects}}',
  'code-remedy.mass-remediate.apply-fixes.loading': 'Applying fixes to {count, plural, one {object} other {# objects}}...',
  'code-remedy.mass-remediate.apply-fixes.partial-success': 'Applied fixes to {count} out of {total} {total, plural, one {object} other {objects}}',
  'code-remedy.mass-remediate.apply-fixes.success': 'Successfully applied fixes to {count, plural, one {object} other {# objects}}',
  'code-remedy.mass-remediate.modal.apply.description': 'Apply selected fixes ({count} {count, plural, one {object} other {objects}} selected)',
  'code-remedy.mass-remediate.modal.back': 'Back',
  'code-remedy.mass-remediate.modal.description': 'Select files to search for {count} {count, plural, one {fix} other {fixes}} (across {total} {total, plural, one {object or subobject} other {objects and subobjects}})',
  'code-remedy.mass-remediate.modal.footer.label.apply-results-summary': '{success} successful • {failed} failed',
  'code-remedy.mass-remediate.modal.footer.label.processed': '{count} of {total} {total, plural, one {object} other {objects}} processed',
  'code-remedy.mass-remediate.modal.footer.label.selected': '{count} of {total} {total, plural, one {object} other {objects}} selected',
  'code-remedy.mass-remediate.modal.footer.label.success': '{count} of {total} {total, plural, one {object} other {objects}} fixed successfully',
  'code-remedy.mass-remediate.modal.retry': 'Retry',
  'code-remedy.mass-remediate.modal.retry-failed': 'Retry Failed',
  'code-remedy.mass-remediate.modal.review.description': 'Review and select fixes to apply ({count} {count, plural, one {object} other {objects}} with issues)',
  'code-remedy.mass-remediate.modal.select': 'Select',
  'code-remedy.mass-remediate.modal.title': 'Mass Remediate',
  'common.actions': 'Actions',
  'common.add': 'Add',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.create': 'Create',
  'common.delete': 'Delete',
  'common.docs': 'Open Documentation',
  'common.edit': 'Edit',
  'common.false': 'False',
  'common.goBack': 'Go Back',
  'common.save': 'Save',
  'common.true': 'True',
  'common.unknownError': 'Unknown error',
  'connectors.action.edit': 'Edit system',
  'connectors.action.saveChanges': 'Save changes',
  'connectors.field.default': 'Default',
  'connectors.field.default.description': 'Set as the default system for this domain',
  'connectors.field.description': 'Description',
  'connectors.field.description.placeholder': 'Optional description',
  'connectors.field.domain': 'Domain',
  'connectors.field.domain.locked': 'Domain cannot be changed after creation.',
  'connectors.field.domain.placeholder': 'Select domain',
  'connectors.field.name': 'Display name',
  'connectors.field.name.identifierLocked': 'Identifier: {identifier} (cannot be changed)',
  'connectors.field.name.placeholder': 'e.g. SAP Production',
  'connectors.field.version': 'Version',
  'connectors.field.version.placeholder': 'Select version',
  'connectors.status.active': 'Active',
  'connectors.status.inactive': 'Inactive',
  'conversation.exportWorkflow.buildManually': 'Build Manually',
  'conversation.exportWorkflow.cancel': 'Cancel',
  'conversation.exportWorkflow.close': 'Close',
  'conversation.exportWorkflow.description': 'Analyzing your conversation...',
  'conversation.exportWorkflow.descriptionReady': 'Generated {count, plural, one {# node} other {# nodes}} — review before opening in the editor.',
  'conversation.exportWorkflow.dismissAriaLabel': 'Dismiss',
  'conversation.exportWorkflow.issueToast.action': 'View details',
  'conversation.exportWorkflow.issueToast.title': "Couldn't generate workflow",
  'conversation.exportWorkflow.missingNodesDescription': "Some tools used in this conversation don't have workflow nodes yet.",
  'conversation.exportWorkflow.missingNodesTitle': "Can't generate this workflow yet",
  'conversation.exportWorkflow.openEditor': 'Open in Workflow Editor',
  'conversation.exportWorkflow.pill.cancelAriaLabel': 'Cancel workflow generation',
  'conversation.exportWorkflow.pill.generating': 'Generating workflow…',
  'conversation.exportWorkflow.pill.issue': "Couldn't generate workflow",
  'conversation.exportWorkflow.pill.ready': 'Workflow ready',
  'conversation.exportWorkflow.pill.restoreAriaLabel': 'Reopen workflow generation',
  'conversation.exportWorkflow.preview.empty': 'No nodes to preview',
  'conversation.exportWorkflow.previewLabel': 'Workflow Preview',
  'conversation.exportWorkflow.readyToast.action': 'Open in Workflow Editor',
  'conversation.exportWorkflow.readyToast.description': 'Your generated workflow is ready to review.',
  'conversation.exportWorkflow.readyToast.title': 'Workflow ready',
  'conversation.exportWorkflow.step.analyze': 'Analyzing conversation',
  'conversation.exportWorkflow.step.generate': 'Generating with AI',
  'conversation.exportWorkflow.step.validate': 'Validating graph',
  'conversation.exportWorkflow.stream.backToLatest': 'Back to latest',
  'conversation.exportWorkflow.stream.building': 'building…',
  'conversation.exportWorkflow.stream.connections': '{count, plural, one {# connection} other {# connections}}',
  'conversation.exportWorkflow.title': 'Generating Workflow',
  'conversation.exportWorkflow.titleReady': 'Workflow Ready',
  'conversation.exportWorkflow.toast.dismiss': 'Dismiss',
  'conversation.exportWorkflow.unsupportedTools': '{count, plural, one {# tool was} other {# tools were}} skipped (unsupported): {names}',
  'conversation.exportWorkflow.validationIssuesOverflow': '…and {count} more',
  'conversation.exportWorkflow.validationIssuesTitle': 'Some nodes may need attention in the editor',
  'conversation.list.newConversation': 'New chat',
  'data-foundry.download.allAsCsv': 'Download All as CSV',
  'data-foundry.download.allAsExcel': 'Download All as Excel',
  'data-foundry.download.pageAsCsv': 'Download Page as CSV',
  'data-foundry.download.pageAsJson': 'Download Page as JSON',
  'data-harmonization.dashboard.addToFavorites': 'Add to favorites',
  'data-harmonization.dashboard.analyticsCreateGraph': 'Add Graph',
  'data-harmonization.dashboard.analyticsEmptyGridDescription': 'Graphs will appear here when a dashboard editor adds them.',
  'data-harmonization.dashboard.analyticsEmptyGridTitle': 'No graphs yet',
  'data-harmonization.dashboard.analyticsImportGraphs': 'Import',
  'data-harmonization.dashboard.batchExecutions.deleteBatchExecutions': 'Delete {count,plural, one {Batch Execution} other {Batch Executions}}',
  'data-harmonization.dashboard.batchExecutions.deleteBatchExecutionsVerification': 'Are you sure you want to delete {count,plural, one {this batch execution} other {these {count} batch executions}}? Any associated data check executions and error tracking refreshes will also be deleted. This action cannot be undone.',
  'data-harmonization.dashboard.cancelLayoutTooltip': 'Discard changes',
  'data-harmonization.dashboard.dataChecks': 'Data Checks',
  'data-harmonization.dashboard.datachecks.loadingDataChecks': 'Loading Data Checks...',
  'data-harmonization.dashboard.datachecks.remove': 'Remove {count,plural, one {Data Check} other {Data Checks}}',
  'data-harmonization.dashboard.datachecks.summaryCount': 'Showing {total} {total,plural, one {Data Check} other {Data Checks}}',
  'data-harmonization.dashboard.datachecks.summaryCountFiltered': 'Showing {filteredRowCount} out of {total} {total,plural, one {Data Check} other {Data Checks}}',
  'data-harmonization.dashboard.downloadGraphsTooltip': 'Download graphs',
  'data-harmonization.dashboard.editFiltersTooltip': 'Edit filters',
  'data-harmonization.dashboard.editingLayout': 'Drag a card to reorder, drag its edges to resize — then save or cancel the new layout',
  'data-harmonization.dashboard.editLayoutTooltip': 'Edit layout',
  'data-harmonization.dashboard.errorTracking.deleteErrorTracking': 'Delete {count,plural, one {Error Tracking Entry} other {Error Tracking Entries}}',
  'data-harmonization.dashboard.errorTracking.deleteErrorTrackingVerification': 'Are you sure you want to delete {count,plural, one {this error tracking entry} other {these {count} error tracking entries}}? This action cannot be undone.',
  'data-harmonization.dashboard.executeAllButton': 'Execute All Data Checks',
  'data-harmonization.dashboard.executeAllTooltip': 'Execute all data checks in this dashboard',
  'data-harmonization.dashboard.executions.deleteExecution': 'Delete {execCount,plural, one {Execution} other {Executions}}',
  'data-harmonization.dashboard.executions.deleteExecutionError': 'Failed to delete {execCount,plural, one {execution} other {executions}}',
  'data-harmonization.dashboard.executions.deleteExecutionSuccess': '{execCount,plural, one {Execution} other {Executions}} deleted successfully',
  'data-harmonization.dashboard.executions.deleteExecutionVerification': 'Are you sure you want to delete {execCount,plural, one {this execution} other {these {execCount} executions}}?',
  'data-harmonization.dashboard.hideFiltersTooltip': 'Hide filters',
  'data-harmonization.dashboard.lastExecution': 'Last Execution',
  'data-harmonization.dashboard.noExecutions': 'No executions yet',
  'data-harmonization.dashboard.notFoundDescription': "The dashboard with ID '{dashboardId}' does not exist.",
  'data-harmonization.dashboard.notFoundTitle': 'Dashboard Not Found',
  'data-harmonization.dashboard.preferencesTooltip': 'Dashboard Preferences',
  'data-harmonization.dashboard.removeFromFavorites': 'Remove from favorites',
  'data-harmonization.dashboard.saveLayoutTooltip': 'Save layout',
  'data-harmonization.dashboard.settings.excludeDimensionsIncrementality': 'Dimensions to exclude from incrementality calculations',
  'data-harmonization.dashboard.settings.excludeDimensionsQualityScore': 'Dimensions to exclude from quality score calculations',
  'data-harmonization.dashboard.share.actions.delete': 'Delete permission',
  'data-harmonization.dashboard.share.actions.restore': 'Restore access',
  'data-harmonization.dashboard.share.actions.revoke': 'Revoke access',
  'data-harmonization.dashboard.share.addButton': 'Share',
  'data-harmonization.dashboard.share.description': 'Invite teammates to collaborate on this dashboard by setting their access level.',
  'data-harmonization.dashboard.share.duplicateEmail': 'This user already has a permission entry.',
  'data-harmonization.dashboard.share.emailLabel': 'Email',
  'data-harmonization.dashboard.share.emailPlaceholder': 'user@example.com',
  'data-harmonization.dashboard.share.emptyState': 'No permissions found yet.',
  'data-harmonization.dashboard.share.grantedBy': 'Granted by {name}',
  'data-harmonization.dashboard.share.invalidEmail': 'Enter a valid email address to share this dashboard.',
  'data-harmonization.dashboard.share.loading': 'Loading permissions...',
  'data-harmonization.dashboard.share.noUsers': 'No users found. Try another search.',
  'data-harmonization.dashboard.share.permission.editor': 'Editor',
  'data-harmonization.dashboard.share.permission.viewer': 'Viewer',
  'data-harmonization.dashboard.share.permissionLabel': 'Permission',
  'data-harmonization.dashboard.share.removeEmail': 'Remove {email}',
  'data-harmonization.dashboard.share.revoked': 'Revoked',
  'data-harmonization.dashboard.share.revokedBy': 'Revoked by {name}',
  'data-harmonization.dashboard.share.searching': 'Searching users...',
  'data-harmonization.dashboard.share.selectUserRequired': 'Select a user from the list to share this dashboard.',
  'data-harmonization.dashboard.share.tab.active': 'Active',
  'data-harmonization.dashboard.share.tab.revoked': 'Revoked',
  'data-harmonization.dashboard.share.title': 'Share Dashboard',
  'data-harmonization.dashboard.share.toast.createSuccess': 'Shared with {count,plural, one {{email}} other {# users}}',
  'data-harmonization.dashboard.share.toast.creating': 'Sharing dashboard...',
  'data-harmonization.dashboard.share.toast.deleteSuccess': 'Removed share for {email}',
  'data-harmonization.dashboard.share.toast.error': 'Unable to update sharing settings.',
  'data-harmonization.dashboard.share.toast.restoreSuccess': 'Restored access for {email}',
  'data-harmonization.dashboard.share.toast.revokeSuccess': 'Revoked access for {email}',
  'data-harmonization.dashboard.share.toast.updateSuccess': 'Updated access for {email}',
  'data-harmonization.dashboard.share.toast.updating': 'Updating permission...',
  'data-harmonization.dashboard.shareTooltip': 'Share',
  'data-harmonization.dashboard.showFiltersTooltip': 'Show filters',
  'data-harmonization.dashboard.targetScore': 'Target Score',
  'data-harmonization.dashboard.views.deleteRefresh': 'Delete {count,plural, one {Refresh} other {Refreshes}}',
  'data-harmonization.dashboard.views.deleteRefreshVerification': 'Are you sure you want to delete {count,plural, one {this refresh} other {these {count} refreshes}}? This action cannot be undone.',
  'data-harmonization.dashboard.workstreamLabel': 'Workstream',
  'editor.chat.attachments.addFilesWithCount': '{count, plural, =0 {Add files} one {Add # file} other {Add # files}}',
  'editor.chat.attachments.addLabel': 'Add attachments',
  'editor.chat.attachments.countLabel': '{count, plural, one {{count} attachment} other {{count} attachments}}',
  'editor.chat.attachments.dropOverlay': 'Drop files to attach to chat',
  'editor.chat.attachments.preview': 'Preview',
  'editor.chat.attachments.selectorModalDescription': 'Upload files from your computer or choose programs from system files.',
  'editor.chat.attachments.uploading': 'Uploading attachments...',
  'editor.chat.conversation.defaultTitle': 'New Chat',
  'editor.chat.copy.buttonLabel': 'Copy',
  'editor.chat.copy.toastSuccess': 'Code snippet copied to clipboard',
  'editor.chat.copy.tooltip': 'Copy code',
  'editor.chat.emptyState.title': 'TESSERA AI',
  'editor.chat.input.cancelRequestTitle': 'Cancel request',
  'editor.chat.input.placeholder': 'Type your message...',
  'editor.chat.input.sendMessageTitle': 'Send message',
  'editor.chat.input.waitForUploadTitle': 'Wait for files to finish uploading',
  'editor.chat.loading': 'Loading conversation...',
  'editor.chat.programSearch.empty': 'No programs found',
  'editor.chat.programSearch.placeholder': 'Search programs...',
  'editor.chat.references.addButton': 'Add references',
  'editor.chat.references.addProgramTooltip': 'Add program',
  'editor.chat.toast.cancelError': 'Failed to cancel request',
  'editor.chat.toast.cancelSuccess': 'Request cancelled',
  'editor.chat.toast.conversationDeleted': 'This conversation may have been deleted',
  'editor.chat.toast.conversationHistoryError': 'Failed to load conversation history',
  'editor.chat.toast.sendError': 'Failed to send message. Please try again.',
  'editor.library.projectSettings.ariaLabel': 'Project settings and rules',
  'editor.rulesFile.deleteConfirm.action': 'Delete',
  'editor.rulesFile.deleteConfirm.cancel': 'Cancel',
  'editor.rulesFile.deleteConfirm.description': 'The file is empty. Saving will permanently delete it.',
  'editor.rulesFile.deleteConfirm.title': 'Delete {filename}?',
  'editor.rulesFile.placeholder.agents': 'Write your agent definitions here in Markdown...',
  'editor.rulesFile.placeholder.rules': 'Write your rules and guidelines here in Markdown...',
  'editor.rulesFile.saveButton': 'Save {filename}',
  'editor.rulesFile.toast.deleted': '{filename} deleted',
  'editor.rulesFile.toast.deleteError': 'Failed to delete {filename}',
  'editor.rulesFile.toast.deleting': 'Deleting {filename}…',
  'editor.rulesFile.toast.saved': '{filename} saved',
  'editor.rulesFile.toast.saveError': 'Failed to save {filename}',
  'editor.rulesFile.toast.saving': 'Saving {filename}…',
  'editor.workbench.actions.globalRulesLink': 'Global Rules & Skills',
  'editor.workbench.globalRules.description': 'These files are automatically attached to every chat and code generation request across all editor sessions. Project-level files take precedence when defined.',
  'editor.workbench.globalRules.heading': 'Global Rules & Skills',
  'editor.workbench.globalRules.skills.description': 'Skills available across all editor sessions.',
  'editor.workbench.globalRules.skills.heading': 'Skills',
  'editor.workbench.rulesAndSkills.description': 'These files are automatically attached to every chat and code generation request in this project.',
  'editor.workbench.rulesAndSkills.heading': 'Rules & Skills',
  'editor.workbench.rulesAndSkills.skills.description': 'Skills for this project.',
  'editor.workbench.rulesAndSkills.skills.heading': 'Skills',
  'editor.workbench.rulesAndSkills.tabLabel': 'Rules & Skills',
  'editor.workbench.settings.backAriaLabel': 'Back to workbench',
  'editor.workbench.settings.title': 'Global Rules & Skills',
  'home.chooseWorkstream': 'Choose workstream',
  'home.chooseWorkstreamSubtitle': 'Choose a workstream, or pick up where you left off.',
  'home.emptyState.description': "Your account is active, but you haven't been granted access to any workstreams. Contact your workspace admin and they will take it from there.",
  'home.emptyState.title': 'No workstreams assigned yet',
  'home.noAccessToAny': "You currently don't have access to any features. Please contact your administrator.",
  'loom.versionViewer.afterSave': 'After save',
  'loom.versionViewer.cancel': 'Cancel',
  'loom.versionViewer.changeSummary': 'Change summary',
  'loom.versionViewer.changeSummaryHint': '(optional · saved to version history)',
  'loom.versionViewer.changeSummaryPlaceholder': 'Briefly describe what changed...',
  'loom.versionViewer.chip.added': '{count} added',
  'loom.versionViewer.chip.connections': '{count, plural, one {# connection} other {# connections}}',
  'loom.versionViewer.chip.metadata': 'metadata',
  'loom.versionViewer.chip.modified': '{count} modified',
  'loom.versionViewer.chip.removed': '{count} removed',
  'loom.versionViewer.condition.label': 'condition',
  'loom.versionViewer.condition.op.eq': 'equals',
  'loom.versionViewer.condition.op.gt': 'is greater than',
  'loom.versionViewer.condition.op.gte': 'is at least',
  'loom.versionViewer.condition.op.lt': 'is less than',
  'loom.versionViewer.condition.op.lte': 'is at most',
  'loom.versionViewer.condition.op.ne': 'does not equal',
  'loom.versionViewer.confirmSave': 'Confirm & save',
  'loom.versionViewer.field.collapse': 'collapse',
  'loom.versionViewer.field.expand': 'expand',
  'loom.versionViewer.field.linesAdded': 'added',
  'loom.versionViewer.field.linesCount': '{count} lines',
  'loom.versionViewer.field.linesModified': 'modified',
  'loom.versionViewer.field.linesRemoved': 'removed',
  'loom.versionViewer.field.shapeArrow': '{before} → {after}',
  'loom.versionViewer.format.kindCombined': 'combined',
  'loom.versionViewer.format.kindNodeOutput': 'node output',
  'loom.versionViewer.format.kindUnknown': 'unknown',
  'loom.versionViewer.format.kindWfInput': 'workflow input',
  'loom.versionViewer.format.unserializable': '<unserializable>',
  'loom.versionViewer.format.workflowInputRef': '↗ Workflow input · {paramName}',
  'loom.versionViewer.generateSummary': 'Generate',
  'loom.versionViewer.generateSummaryError': "Couldn't generate a summary — you can still write one yourself.",
  'loom.versionViewer.generatingSummary': 'Generating...',
  'loom.versionViewer.graphPreview': 'Graph preview',
  'loom.versionViewer.legend.added': 'added',
  'loom.versionViewer.legend.modified': 'modified',
  'loom.versionViewer.legend.removed': 'removed',
  'loom.versionViewer.legend.unchanged': 'unchanged',
  'loom.versionViewer.node.changesCount': '{count, plural, one {# change} other {# changes}}',
  'loom.versionViewer.node.fieldActivity': 'activity',
  'loom.versionViewer.node.fieldDescription': 'description',
  'loom.versionViewer.node.fieldName': 'name',
  'loom.versionViewer.node.fieldOnFailure': 'if this step fails',
  'loom.versionViewer.node.fieldsCount': '{count, plural, one {# field} other {# fields}}',
  'loom.versionViewer.node.fieldTimeout': 'timeout',
  'loom.versionViewer.node.policyContinue': 'Continue the workflow',
  'loom.versionViewer.node.policyFailWorkflow': 'Stop the workflow',
  'loom.versionViewer.node.renamedBadge': 'renamed',
  'loom.versionViewer.node.timeoutDefault': 'Step default',
  'loom.versionViewer.node.timeoutSeconds': '{count}s',
  'loom.versionViewer.none': '(none)',
  'loom.versionViewer.preview.empty': 'No nodes to preview',
  'loom.versionViewer.saving': 'Saving...',
  'loom.versionViewer.section.added': 'Added',
  'loom.versionViewer.section.connections': 'Connections',
  'loom.versionViewer.section.inputs': 'Inputs',
  'loom.versionViewer.section.modified': 'Modified',
  'loom.versionViewer.section.nodes': 'Nodes',
  'loom.versionViewer.section.removed': 'Removed',
  'loom.versionViewer.section.workflow': 'Workflow',
  'loom.versionViewer.subtitle': 'Confirm the workflow edits below before they are saved.',
  'loom.versionViewer.title': 'Review changes before saving',
  'loom.visibility.private': 'Private',
  'loom.visibility.public': 'Public',
  'loom.visibility.shared': 'Shared',
  'nexus.builder.auditLog': 'Review audit log',
  'nexus.builder.cta.addSources': 'Add sources',
  'nexus.builder.cta.propose': 'Auto-map fields',
  'nexus.builder.defaultName': 'Mapping',
  'nexus.builder.doubleClickToRename': 'Double-click to rename',
  'nexus.builder.exportDisabledTooltip': 'Add mappings before exporting.',
  'nexus.builder.exportFailed': 'Export failed. Try again.',
  'nexus.builder.moreActions': 'More actions',
  'nexus.builder.share': 'Share',
  'nexus.catalogChip.tooltip': 'Source catalog these tables come from',
  'nexus.createBlueprint.descLabel': 'Description (optional)',
  'nexus.createBlueprint.descPlaceholder': 'What this mapping covers — systems, scope, purpose…',
  'nexus.createBlueprint.description': 'Name your schema mapping. You can rename it later.',
  'nexus.createBlueprint.nameLabel': 'Name',
  'nexus.createBlueprint.sourceSystemLabel': 'Source system (optional)',
  'nexus.createBlueprint.submit': 'Create mapping',
  'nexus.createBlueprint.systemNone': 'None',
  'nexus.createBlueprint.targetSystemLabel': 'Target system (optional)',
  'nexus.createBlueprint.title': 'New mapping',
  'nexus.edgeDetail.businessDescription': 'Business Description',
  'nexus.edgeDetail.cardinality': 'Cardinality',
  'nexus.edgeDetail.confidence': 'Confidence:',
  'nexus.edgeDetail.deleteEdge': 'Delete edge',
  'nexus.edgeDetail.derivedFrom': 'Derived from',
  'nexus.edgeDetail.descriptionPlaceholder': 'Describe the business relationship...',
  'nexus.edgeDetail.edgeDeleted': 'Edge deleted',
  'nexus.edgeDetail.fieldMappings': 'Field Mappings',
  'nexus.edgeDetail.joinKeys': 'Join Keys',
  'nexus.edgeDetail.mappingCount': '{count, plural, one {# mapping} other {# mappings}}',
  'nexus.edgeDetail.mappingsShowingWeakest': 'Showing {shown} lowest-confidence of {total}',
  'nexus.edgeDetail.mappingsViewAll': 'View all {count} in Fields',
  'nexus.edgeDetail.noFieldMappings': 'No field mappings yet',
  'nexus.edgeDetail.notSet': 'Not set',
  'nexus.edgeDetail.openInDrawer': 'Open in mapping drawer',
  'nexus.edgeDetail.syntheticExplainer': "This link is generated from your field mappings. Edit the mappings to change it — there's no join key or cardinality to set.",
  'nexus.edgeDetail.syntheticTitle': 'Field-mapping link',
  'nexus.edgeDetail.title': 'Edge Detail',
  'nexus.editBlueprint.description': 'Update the name, description, and connected systems.',
  'nexus.editBlueprint.nameRequired': 'Name is required.',
  'nexus.editBlueprint.submit': 'Save changes',
  'nexus.editBlueprint.title': 'Edit mapping details',
  'nexus.fieldCombobox.empty': 'No fields',
  'nexus.fieldCombobox.searchPlaceholder': 'Search fields…',
  'nexus.graph.button.layout': 'Layout',
  'nexus.graph.mapHint': '⌘-click another table to propose a mapping between them',
  'nexus.graph.nodeBadge.modified': 'Modified',
  'nexus.graph.nodeBadge.new': 'New',
  'nexus.graph.onboardHint': 'Click a table to inspect its fields · ⌘-click to select tables and propose mappings',
  'nexus.import.another': 'Import another',
  'nexus.import.button': 'Import mappings',
  'nexus.import.description': 'Upload a CSV or XLSX of field mappings. Resolvable rows are filed as proposals for review.',
  'nexus.import.downloadTemplate': 'Download template',
  'nexus.import.dropzone': 'Drop a CSV/XLSX file or click to browse',
  'nexus.import.issuesHeading': 'Rows needing attention',
  'nexus.import.resultHeading': '{total, plural, one {# row} other {# rows}} processed',
  'nexus.import.rowLabel': 'Row {row}',
  'nexus.import.statFailed': 'Failed',
  'nexus.import.statFiled': 'Filed',
  'nexus.import.statSkipped': 'Skipped',
  'nexus.import.statUnbound': 'Unbound',
  'nexus.import.templateFailed': 'Could not load the template.',
  'nexus.import.title': 'Import field mappings',
  'nexus.import.toastFailed': 'Import failed. Check the file and try again.',
  'nexus.knowledge.documentsHeading': '{count, plural, =0 {Documents} other {Documents (#)}}',
  'nexus.knowledge.emptyDocs': "No documents yet. Upload a glossary or spec to ground the AI's mapping proposals.",
  'nexus.knowledge.includeOrgKbHelp': "Your uploaded documents stay private to this mapping. Enabling this also lets the AI read your organization's shared knowledge base when proposing mappings.",
  'nexus.knowledge.includeOrgKbLabel': 'Also search the organization knowledge base',
  'nexus.knowledge.includeOrgKbToastFailed': 'Failed to update knowledge base setting',
  'nexus.knowledge.intro': 'Upload docs, glossaries, and mapping specs scoped to this blueprint. They stay private to it and the AI reads them when proposing mappings.',
  'nexus.knowledge.loadingDocs': 'Loading documents…',
  'nexus.knowledge.manageOrgKb': 'Manage the organization knowledge base →',
  'nexus.knowledge.popoverTooltip': 'Supporting documents the AI reads when proposing mappings',
  'nexus.knowledge.removeDocTitle': 'Remove document',
  'nexus.knowledge.removeFailed': 'Failed to remove {filename}',
  'nexus.knowledge.removeSuccess': 'Removed {filename}',
  'nexus.knowledge.title': 'Knowledge',
  'nexus.knowledge.uploadButton': 'Upload document',
  'nexus.knowledge.uploadFailed': 'Failed to upload {filename}',
  'nexus.knowledge.uploadSuccess': "Added {filename} to this blueprint's knowledge",
  'nexus.leftPanel.tab.graph': 'Graph',
  'nexus.leftPanel.tab.graph.tooltip': 'Canvas: tables and the relationships between them',
  'nexus.leftPanel.tab.knowledge': 'Knowledge',
  'nexus.leftPanel.tab.mappings': 'Fields',
  'nexus.leftPanel.tab.mappings.tooltip': 'Field-by-field mapping table (source field → target field)',
  'nexus.leftPanel.tab.propose': 'Propose mappings',
  'nexus.leftPanel.tab.propose.tooltip': 'Let the AI propose mappings, then review them',
  'nexus.leftPanel.tab.reviews': 'Reviews',
  'nexus.leftPanel.tab.sources': 'Sources',
  'nexus.legend.acceptedRelationship': 'Accepted relationship',
  'nexus.legend.proposedMapping': 'Proposed mapping (pending review)',
  'nexus.legend.table': 'Table',
  'nexus.legend.title': 'Legend',
  'nexus.library.activeFilters': '{count, plural, one {# filter} other {# filters}}',
  'nexus.library.anySource': 'Any source',
  'nexus.library.anyTarget': 'Any target',
  'nexus.library.backToLibrary': 'Back to Library',
  'nexus.library.card.mappings': '{count, plural, one {# field mapping} other {# field mappings}}',
  'nexus.library.card.updated': 'Updated {date}',
  'nexus.library.createFailed': "Couldn't create a mapping from this template.",
  'nexus.library.createJobFailed': 'The mapping was created but could not be filled from this template. {reason}',
  'nexus.library.createMapping': 'Create mapping',
  'nexus.library.createPartial': 'Created. {count, plural, one {# table is} other {# tables are}} not in your lakehouse yet ({systems}), so their fields come from the template rather than your data. Connect the source or upload the tables to fill them in.',
  'nexus.library.createStillPopulating': 'Still copying the template in. Opening the mapping — it fills as the copy runs.',
  'nexus.library.createSucceeded': 'Created a mapping from {name}.',
  'nexus.library.description': 'Reusable mapping templates. Start from one instead of an empty canvas.',
  'nexus.library.drawer.close': 'Close template detail',
  'nexus.library.drawer.directCopy': 'Direct copy — no transform.',
  'nexus.library.drawer.fields': '{count, plural, one {# field} other {# fields}}',
  'nexus.library.drawer.mappings': 'Field mappings',
  'nexus.library.drawer.mappingsError': "This template's mappings couldn't be loaded.",
  'nexus.library.drawer.noMappings': 'This template carries no field mappings.',
  'nexus.library.drawer.previewCount': 'Transforms first · {shown} of {total}',
  'nexus.library.drawer.tables': '{count, plural, one {# table} other {# tables}}',
  'nexus.library.drawer.transforms': '{count, plural, one {# transform} other {# transforms}}',
  'nexus.library.drawer.unknownTransform': 'Transformed — rule not recognised.',
  'nexus.library.empty': 'The Library has no templates yet.',
  'nexus.library.loadError': "The Library couldn't be loaded.",
  'nexus.library.noSearchMatch': 'No templates match. Try a wider search or clear the filters.',
  'nexus.library.openFullView': 'Open full view',
  'nexus.library.pageOf': 'Page {page} of {total}',
  'nexus.library.readOnlyBody': 'Shared definitions are not edited here. Create a mapping from it to start real work.',
  'nexus.library.readOnlyTitle': 'Library template · read-only',
  'nexus.library.retry': 'Try again',
  'nexus.library.searchPlaceholder': 'Search templates, tables or fields',
  'nexus.library.sortLabel': 'Sort templates',
  'nexus.library.sortName': 'Name',
  'nexus.library.sortRecent': 'Recently updated',
  'nexus.library.sourceSystem': 'Source system',
  'nexus.library.targetSystem': 'Target system',
  'nexus.library.title': 'Library',
  'nexus.mappings.accept': 'Accept',
  'nexus.mappings.bulk.acceptAll': 'Accept all',
  'nexus.mappings.bulk.capTip': 'Only {cap, number} can be actioned at once — narrow the view.',
  'nexus.mappings.bulk.confirmAcceptBody': 'Every proposed mapping currently in view will be accepted onto the blueprint.',
  'nexus.mappings.bulk.confirmAcceptTitle': 'Accept {count, plural, one {# proposal} other {# proposals}}?',
  'nexus.mappings.bulk.confirmRejectBody': 'Every proposed mapping currently in view will be rejected.',
  'nexus.mappings.bulk.confirmRejectTitle': 'Reject {count, plural, one {# proposal} other {# proposals}}?',
  'nexus.mappings.bulk.proposedCount': '{count, plural, one {# proposal} other {# proposals}} in view',
  'nexus.mappings.bulk.rejectAll': 'Reject all',
  'nexus.mappings.bulk.toastAccepted': '{count, plural, one {# mapping accepted} other {# mappings accepted}}',
  'nexus.mappings.bulk.toastFailed': '{count} failed — retry',
  'nexus.mappings.bulk.toastRejected': '{count, plural, one {# proposal rejected} other {# proposals rejected}}',
  'nexus.mappings.bulk.toastStale': '{count} already resolved by another reviewer',
  'nexus.mappings.changeModified': 'Changed',
  'nexus.mappings.changeNew': 'New',
  'nexus.mappings.clearFilters': 'Clear filters',
  'nexus.mappings.col.confidence': 'Conf.',
  'nexus.mappings.col.source': 'Source',
  'nexus.mappings.col.srcExample': 'SRC example value',
  'nexus.mappings.col.srcField': 'Src field',
  'nexus.mappings.col.srcTable': 'Src table',
  'nexus.mappings.col.status': 'Status',
  'nexus.mappings.col.target': 'Target',
  'nexus.mappings.col.tgtExample': 'TGT example value',
  'nexus.mappings.col.tgtField': 'Tgt field',
  'nexus.mappings.col.tgtTable': 'Tgt table',
  'nexus.mappings.col.transform': 'Transformation',
  'nexus.mappings.col.type': 'Type',
  'nexus.mappings.comments': 'Comments',
  'nexus.mappings.conformance': '{rate}% conform · {rule}',
  'nexus.mappings.conformanceCaption': 'of sampled source values fit the target {rule} column',
  'nexus.mappings.delete': 'Delete mapping',
  'nexus.mappings.edgeCount': '{count, plural, one {# mapping} other {# mappings}}',
  'nexus.mappings.edit': 'Edit mapping',
  'nexus.mappings.empty': 'No mappings match this view.',
  'nexus.mappings.error': 'Could not load mappings.',
  'nexus.mappings.filter.all': 'All',
  'nexus.mappings.filter.mapped': 'Mapped',
  'nexus.mappings.filter.proposed': 'Proposed',
  'nexus.mappings.filter.srcField': 'Source field',
  'nexus.mappings.filter.srcTable': 'Source table',
  'nexus.mappings.filter.tgtField': 'Target field',
  'nexus.mappings.filter.tgtTable': 'Target table',
  'nexus.mappings.filter.unmapped': 'Unmapped',
  'nexus.mappings.matchCaption': '{overlap} of {total} source values also in target',
  'nexus.mappings.matchRateTooltip': '{rate}% match — validated',
  'nexus.mappings.needAttentionCount': '{count, plural, one {# needs attention} other {# need attention}}',
  'nexus.mappings.needsAttention': 'Low confidence — review carefully',
  'nexus.mappings.noFilterMatch': 'No mappings match this filter.',
  'nexus.mappings.nonconforming': "Doesn't fit target",
  'nexus.mappings.notValidated': 'Not validated',
  'nexus.mappings.openThreadsChip': 'Open threads',
  'nexus.mappings.pageNext': 'Next page',
  'nexus.mappings.pageOf': '{page} / {total}',
  'nexus.mappings.pagePrev': 'Previous page',
  'nexus.mappings.pageRange': '{start}–{end} of {total}',
  'nexus.mappings.proposalsLoadError': "Couldn't load all proposals.",
  'nexus.mappings.reject': 'Reject',
  'nexus.mappings.resetColumns': 'Reset filters and columns',
  'nexus.mappings.searchPlaceholder': 'Search fields…',
  'nexus.mappings.sourceSample': 'Source values',
  'nexus.mappings.status.accepted': 'Accepted',
  'nexus.mappings.status.confirmed': 'Confirmed',
  'nexus.mappings.status.mapped': 'Mapped',
  'nexus.mappings.status.proposed': 'Proposed',
  'nexus.mappings.status.rejected': 'Rejected',
  'nexus.mappings.status.suggested': 'Suggested',
  'nexus.mappings.status.unmapped': 'Unmapped',
  'nexus.mappings.tab.accepted': 'Accepted',
  'nexus.mappings.tab.proposed': 'Proposed',
  'nexus.mappings.tab.rejected': 'Rejected',
  'nexus.mappings.tab.unmapped': 'Unmapped',
  'nexus.mappings.targetEmpty': 'Target has no live data to compare against yet',
  'nexus.mappings.targetRequired': 'Target field is required',
  'nexus.mappings.toast.accepted': 'Mapping accepted',
  'nexus.mappings.toast.failed': 'Action failed',
  'nexus.mappings.toast.rejected': 'Proposal rejected',
  'nexus.mappings.validate': 'Validate against live data',
  'nexus.mappings.validateAll': 'Validate all',
  'nexus.mappings.validateAllProposedResult': '{conforming}/{total} conform',
  'nexus.mappings.validateAllProposedTooltip': 'Validate all proposals against live data',
  'nexus.mappings.validateAllResult': '{succeeded}/{total} validated',
  'nexus.mappings.validateProposed': 'Validate proposed',
  'nexus.newMapping.create': 'Map these tables',
  'nexus.newMapping.pickTables': 'Pick the source and target tables to map',
  'nexus.newMapping.source': 'Source table',
  'nexus.newMapping.target': 'Target table',
  'nexus.node.deleteFromCanvas': 'Delete source',
  'nexus.nodeDetail.exportCsv': 'CSV',
  'nexus.nodeDetail.failedToLoad': 'Failed to load table data',
  'nexus.nodeDetail.field': 'Field:',
  'nexus.nodeDetail.fieldHeader': 'Field',
  'nexus.nodeDetail.fields': 'Fields:',
  'nexus.nodeDetail.fieldsCount': '{count} fields',
  'nexus.nodeDetail.loadingData': 'Loading data...',
  'nexus.nodeDetail.noData': 'No data available',
  'nexus.nodeDetail.noFields': 'No fields found',
  'nexus.nodeDetail.optionalBadge': 'optional',
  'nexus.nodeDetail.requiredBadge': 'required',
  'nexus.nodeDetail.rowCount': '{count} rows',
  'nexus.nodeDetail.rows': 'Rows:',
  'nexus.nodeDetail.rowsCount': '{count} rows',
  'nexus.nodeDetail.system': 'System:',
  'nexus.nodeDetail.tab.data': 'Data',
  'nexus.nodeDetail.tab.query': 'Query',
  'nexus.nodeDetail.tab.schema': 'Schema',
  'nexus.nodeDetail.tab.scope': 'Scope',
  'nexus.nodeDetail.typeHeader': 'Type',
  'nexus.onboard.cta.addSources': 'Add sources',
  'nexus.onboard.cta.openCanvas': 'Open the canvas',
  'nexus.onboard.cta.review': 'Review fields',
  'nexus.onboard.step.propose': 'Auto-map fields',
  'nexus.onboard.step.propose.desc': 'Run Plexus on the canvas',
  'nexus.onboard.step.review': 'Review & export',
  'nexus.onboard.step.review.desc': 'Accept proposals, export YAML',
  'nexus.onboard.step.sources': 'Add sources',
  'nexus.onboard.step.sources.desc': 'Pick the tables to map',
  'nexus.onboard.subtitle': 'Map a source schema onto a target in three steps.',
  'nexus.onboard.title': "Let's build your mapping",
  'nexus.pagination.next': 'Next',
  'nexus.pagination.prev': 'Prev',
  'nexus.palette.action.addTable': 'Add table…',
  'nexus.palette.action.goToGraph': 'Go to graph',
  'nexus.palette.action.goToMappings': 'Go to fields',
  'nexus.palette.action.goToReviewer': 'Go to reviewer',
  'nexus.palette.action.newBlueprint': 'New mapping',
  'nexus.palette.action.openBlueprint': 'Open mapping…',
  'nexus.palette.action.searchKb': 'Search knowledge base',
  'nexus.palette.empty': 'No matching actions.',
  'nexus.palette.group.actions': 'Actions',
  'nexus.palette.group.blueprints': 'Mappings',
  'nexus.palette.group.navigation': 'Navigation',
  'nexus.palette.group.workbench': 'Workbench',
  'nexus.palette.searchPlaceholder': 'Search actions, mappings, tables…',
  'nexus.plexus.activity.read': 'Read columns from {table}',
  'nexus.plexus.assign.confirm': 'Run column matching ({count, plural, one {# table} other {# tables}})',
  'nexus.plexus.assign.empty': 'No tables on the canvas to run against. Add tables to the project mapping first.',
  'nexus.plexus.assign.error': 'Table assignment failed: {error}',
  'nexus.plexus.assign.include': 'Include',
  'nexus.plexus.assign.intro': 'We matched each source table to the target table its columns most likely belong in. Fix any that look wrong, then run column matching.',
  'nexus.plexus.assign.loading': 'Assigning source tables to target tables…',
  'nexus.plexus.assign.lowAgreement': 'Low agreement',
  'nexus.plexus.assign.parallelism.label': 'Parallelism',
  'nexus.plexus.assign.parallelism.tooltip': 'How many target columns the matcher scores per LLM call — higher is faster but more API load',
  'nexus.plexus.assign.reasonMajority': '{voteCount} of {totalVotes} assignment votes chose {target}.',
  'nexus.plexus.assign.reasonRunnerUp': 'Runner-up: {table} ({voteCount, plural, one {# vote} other {# votes}}).',
  'nexus.plexus.assign.reasonSecondary': 'Some columns may also fit {table}.',
  'nexus.plexus.assign.reasonUnanimous': 'All {totalVotes} assignment votes chose {target}.',
  'nexus.plexus.assign.retry': 'Retry',
  'nexus.plexus.assign.scope.all': 'All columns',
  'nexus.plexus.assign.scope.plural': 'columns',
  'nexus.plexus.assign.scope.search': 'Search columns…',
  'nexus.plexus.assign.scope.title': 'Source columns',
  'nexus.plexus.assign.skip': 'Skip',
  'nexus.plexus.assign.skipped': 'Skipped — this table will not be matched.',
  'nexus.plexus.assign.votes': '{voteCount}/{totalVotes} votes',
  'nexus.plexus.explorationTurn': 'step {turn} of {max}',
  'nexus.plexus.exploringBusinessLogic': 'Exploring business logic',
  'nexus.plexus.knowledge.count': 'This run will read {count, plural, one {# supporting document} other {# supporting documents}} on this blueprint.',
  'nexus.plexus.knowledge.empty': 'No supporting documents — add a spec or mapping sheet to ground these proposals.',
  'nexus.plexus.knowledge.plusOrgKb': 'The organization knowledge base is included too.',
  'nexus.plexus.panel.close': 'Close',
  'nexus.plexus.panel.titleAssign': 'Match tables',
  'nexus.plexus.panel.titleConventions': 'Confirm assumptions',
  'nexus.plexus.panel.titleRunning': 'Deriving mappings',
  'nexus.plexus.panel.titleTriage': 'Review mappings',
  'nexus.plexus.phase.counts': '{done}/{total}',
  'nexus.plexus.phase.enrich': 'Reading columns',
  'nexus.plexus.phase.match': 'Matching {table}',
  'nexus.plexus.phase.matchShort': 'Matching',
  'nexus.plexus.phase.stepOf': 'Step {index} of {count}',
  'nexus.plexus.proposal.accept': 'Accept',
  'nexus.plexus.proposal.accepted': 'Accepted',
  'nexus.plexus.proposal.acceptEdited': 'Accept with new target',
  'nexus.plexus.proposal.associationConfidence': 'Join-path confidence: {value}%',
  'nexus.plexus.proposal.deduped': 'An identical proposal is already open — triage it in the review queue.',
  'nexus.plexus.proposal.editTarget': 'Edit target',
  'nexus.plexus.proposal.evidenceLoading': 'Loading evidence…',
  'nexus.plexus.proposal.expression': 'Expression',
  'nexus.plexus.proposal.joinPath': 'Join path',
  'nexus.plexus.proposal.joinPathHint': 'This value is reached by joining across tables — expand the row for the full path.',
  'nexus.plexus.proposal.matchRate': '{rate}% match',
  'nexus.plexus.proposal.reject': 'Reject',
  'nexus.plexus.proposal.rejected': 'Rejected',
  'nexus.plexus.proposal.selectTarget': 'Select target column',
  'nexus.plexus.proposal.unvalidated': 'unvalidated',
  'nexus.plexus.proposal.why': 'Why this match',
  'nexus.plexus.run.error': 'The run stopped with an error: {error}',
  'nexus.plexus.running.firstRunHint': 'First run builds the column substrate — subsequent runs skip this.',
  'nexus.plexus.running.preparing': 'Preparing column profiles…',
  'nexus.plexus.running.progress': 'Matching table {done} of {total}',
  'nexus.plexus.running.stop': 'Stop',
  'nexus.plexus.running.tableProposals': '{table}: {count, plural, one {# proposal} other {# proposals}}',
  'nexus.plexus.running.triageHint': 'Proposals appear below as they are found — you can accept or reject them right away.',
  'nexus.plexus.scope.availableEmpty': 'Every table is assigned.',
  'nexus.plexus.scope.availableHeading': 'Available',
  'nexus.plexus.scope.intro': 'Assign tables to Sources or Targets — drag, or use the row actions. Unassigned tables sit this run out.',
  'nexus.plexus.scope.remove': 'Remove from run',
  'nexus.plexus.scope.sourcesEmpty': 'Drop source tables here.',
  'nexus.plexus.scope.targetsEmpty': 'Drop target tables here.',
  'nexus.plexus.scope.toSource': 'Move to Sources',
  'nexus.plexus.scope.toTarget': 'Move to Targets',
  'nexus.plexus.step.propose': 'Propose',
  'nexus.plexus.step.review': 'Review',
  'nexus.plexus.step.targets': 'Choose targets',
  'nexus.plexus.target.clickToMove': 'Click to move',
  'nexus.plexus.target.consequence': '{sources, plural, one {# source table} other {# source tables}} will be matched into {targets, plural, one {# target table} other {# target tables}}',
  'nexus.plexus.target.continue': 'Propose',
  'nexus.plexus.target.invertedWarning': 'More targets than sources — most runs map many sources into few targets. Check the panels are not reversed.',
  'nexus.plexus.target.sourcesHeading': 'Sources',
  'nexus.plexus.target.sourceSystemAll': 'All source systems',
  'nexus.plexus.target.sourceSystemLabel': 'Source systems',
  'nexus.plexus.target.sourceSystemPlural': 'systems',
  'nexus.plexus.target.sourceSystemTitle': 'Source systems',
  'nexus.plexus.target.systemIntro': 'This project spans multiple systems. Choose the migration target system.',
  'nexus.plexus.target.systemLabel': 'Target system',
  'nexus.plexus.target.systemPlaceholder': 'Choose a system…',
  'nexus.plexus.target.tablesIntro': 'All project tables share one system. Move the tables you are mapping INTO to the Target panel — everything left under Sources is matched into them.',
  'nexus.plexus.target.targetHeading': 'Targets',
  'nexus.plexus.toast.accepted': 'Proposal accepted.',
  'nexus.plexus.toast.actionFailed': 'Action failed — the proposal was not changed. Try again.',
  'nexus.plexus.toast.edgeAccepted': 'Relationship added to the graph.',
  'nexus.plexus.toast.rejected': 'Proposal rejected.',
  'nexus.plexus.triage.backToCheckpoint': 'Back to table assignments',
  'nexus.plexus.triage.empty': 'No proposals yet.',
  'nexus.plexus.triage.emptyDone': 'The run finished without producing any proposals. Try adjusting the table assignments.',
  'nexus.plexus.triage.summary': '{total, plural, one {# proposal} other {# proposals}} · {accepted} accepted · {rejected} rejected',
  'nexus.preview.columns': 'Columns {shown}/{total}',
  'nexus.preview.jumpToPage': 'Jump to page',
  'nexus.preview.next': 'Next',
  'nexus.preview.ofPages': '/ {total}',
  'nexus.preview.prev': 'Prev',
  'nexus.preview.rowRange': '{from}–{to} of {total}',
  'nexus.project.delete': 'Delete from project',
  'nexus.project.deleteConfirmBody': 'This removes edges and any reviewer proposals. This cannot be undone.',
  'nexus.project.show': 'Show on canvas',
  'nexus.project.toast.deleted': 'Deleted {name}',
  'nexus.project.toast.failedDelete': 'Failed to delete the table.',
  'nexus.project.toast.failedHide': 'Failed to update canvas visibility',
  'nexus.project.toast.failedShow': 'Failed to show the table.',
  'nexus.project.toast.shown': 'Showing {name} on canvas',
  'nexus.projectList.bulkDeleteBody': 'Delete {count} selected {count, plural, one {mapping} other {mappings}}? This cannot be undone.',
  'nexus.projectList.bulkDeleted': 'Deleted {count} mappings',
  'nexus.projectList.bulkDeleteTitle': 'Delete mappings',
  'nexus.projectList.card.mappingsTooltip': '{count} mappings',
  'nexus.projectList.card.noDescription': 'No description yet',
  'nexus.projectList.card.pendingTooltip': '{count} pending review',
  'nexus.projectList.card.select': 'Select {name}',
  'nexus.projectList.card.sourcesTooltip': '{count} sources',
  'nexus.projectList.card.updated': 'Updated {date}',
  'nexus.projectList.column.fields': 'Fields',
  'nexus.projectList.column.name': 'Name',
  'nexus.projectList.column.owner': 'Owner',
  'nexus.projectList.column.pending': 'Pending',
  'nexus.projectList.column.sources': 'Sources',
  'nexus.projectList.column.status': 'Status',
  'nexus.projectList.column.updated': 'Updated',
  'nexus.projectList.createFirst': 'Create your first mapping',
  'nexus.projectList.deleteConfirm': 'Delete Mapping',
  'nexus.projectList.deleteDescription': 'Are you sure you want to delete "{name}"? This will remove all its sources, edges, and field mappings.',
  'nexus.projectList.deleteTitle': 'Delete Mapping',
  'nexus.projectList.description': 'Map and explore relationships across systems',
  'nexus.projectList.editDetails': 'Edit details',
  'nexus.projectList.empty': 'No mappings yet',
  'nexus.projectList.loadError': "Couldn't load your mappings. Refresh to try again.",
  'nexus.projectList.loading': 'Loading...',
  'nexus.projectList.newBlueprint': 'New Mapping',
  'nexus.projectList.noSearchMatch': 'No mappings match your search.',
  'nexus.projectList.rename': 'Rename mapping',
  'nexus.projectList.rowActions': 'Mapping actions',
  'nexus.projectList.scope.all': 'All',
  'nexus.projectList.scope.owned': 'Owned by me',
  'nexus.projectList.scope.shared': 'Shared with me',
  'nexus.projectList.searchPlaceholder': 'Search mappings',
  'nexus.projectList.selectedCount': '{count} selected',
  'nexus.projectList.share': 'Share',
  'nexus.projectList.sort.label': 'Sort',
  'nexus.projectList.sort.name': 'Name',
  'nexus.projectList.sort.recent': 'Recently updated',
  'nexus.projectList.sort.status': 'Status',
  'nexus.projectList.status.awaitingSignoff': 'Awaiting sign-off',
  'nexus.projectList.status.changesRequested': 'Changes requested',
  'nexus.projectList.status.draft': 'Draft',
  'nexus.projectList.status.inProgress': 'In progress',
  'nexus.projectList.status.signedOff': 'Signed off',
  'nexus.projectList.title': 'Nexus',
  'nexus.projectList.updatedDate': 'Updated {date}',
  'nexus.propose.idle.body': 'Pick your source and target tables and the AI proposes field-by-field mappings — one per target column — for you to review here.',
  'nexus.propose.idle.heading': 'Ready to propose mappings',
  'nexus.propose.idle.start': 'Propose mappings',
  'nexus.propose.list.heading': 'Proposals',
  'nexus.propose.page.subtitle': 'AI-proposed field mappings, step by step',
  'nexus.propose.pager.next': 'Next page',
  'nexus.propose.pager.page': '{page} / {pages}',
  'nexus.propose.pager.prev': 'Previous page',
  'nexus.propose.pager.range': '{start}–{end} of {total}',
  'nexus.propose.row.openDetail': 'Open proposal detail',
  'nexus.reviewer.proposalType.edge': 'Edge',
  'nexus.reviewer.proposalType.fieldMapping': 'Mapping',
  'nexus.reviewer.proposalType.schema': 'Schema',
  'nexus.schema.uploadButton': 'Upload schema',
  'nexus.schema.uploadChooseFile': 'Choose file',
  'nexus.schema.uploadFailed': 'Schema upload failed',
  'nexus.schema.uploadSubmit': 'Upload',
  'nexus.schema.uploadSuccess': 'Schema imported: {tables} tables, {fields} fields, {updated} updated, {edges} FKs',
  'nexus.schema.uploadSystemHelp': "Matches rows against that system's existing tables instead of creating duplicates.",
  'nexus.schema.uploadSystemLabel': 'System (optional)',
  'nexus.schema.uploadSystemPlaceholder': 'e.g. Target',
  'nexus.schema.uploadTooltip': 'CSV/XLSX of table + column (+ optional FK, required/optional) definitions',
  'nexus.scopeFilter.addCondition': 'condition',
  'nexus.scopeFilter.addJoinKey': 'join key',
  'nexus.scopeFilter.addLayer': 'Add layer',
  'nexus.scopeFilter.baseColumn': 'base column',
  'nexus.scopeFilter.clear': 'Clear',
  'nexus.scopeFilter.cleared': 'Scope filter cleared.',
  'nexus.scopeFilter.clearError': 'Could not clear the scope filter',
  'nexus.scopeFilter.column': 'column',
  'nexus.scopeFilter.docOnlyNote': '{count} documentation-only predicate(s) recorded, not applied.',
  'nexus.scopeFilter.executable': 'executable (off = documentation-only prose)',
  'nexus.scopeFilter.inScope': 'in scope',
  'nexus.scopeFilter.intro': "Rows this table extracts, before any transform — the migration's scope of record.",
  'nexus.scopeFilter.joinKeys': 'join keys',
  'nexus.scopeFilter.kind.comparison': 'comparison',
  'nexus.scopeFilter.kind.exists': 'exists (join)',
  'nexus.scopeFilter.kind.raw': 'raw / prose',
  'nexus.scopeFilter.layerLabel': 'layer label',
  'nexus.scopeFilter.layerN': 'Layer {n}',
  'nexus.scopeFilter.loadError': "Couldn't load this table's scope filter.",
  'nexus.scopeFilter.notApplied': 'not applied',
  'nexus.scopeFilter.notExists': 'NOT EXISTS',
  'nexus.scopeFilter.preview': 'Preview',
  'nexus.scopeFilter.previewError': 'Preview failed',
  'nexus.scopeFilter.rawPlaceholder': 'raw SQL predicate, or prose',
  'nexus.scopeFilter.readOnly': "You don't have edit access, or the blueprint is signed off — the scope is read-only.",
  'nexus.scopeFilter.relatedColumn': 'related column',
  'nexus.scopeFilter.relatedConditions': 'related-table conditions',
  'nexus.scopeFilter.relatedTable': 'related table (already on canvas)',
  'nexus.scopeFilter.removeLayer': 'Remove layer',
  'nexus.scopeFilter.save': 'Save',
  'nexus.scopeFilter.saved': 'Scope filter saved.',
  'nexus.scopeFilter.saveError': 'Could not save the scope filter',
  'nexus.scopeFilter.totalRows': 'total rows',
  'nexus.scopeFilter.value': 'value',
  'nexus.scopeFilter.valueList': 'a, b, c',
  'nexus.signoffLock.body': 'This blueprint is approved and read-only. Reopen it to make changes.',
  'nexus.signoffLock.reopen': 'Reopen to edit',
  'nexus.signoffLock.reopened': 'Blueprint reopened for editing.',
  'nexus.signoffLock.reopenFailed': 'Failed to reopen the blueprint.',
  'nexus.signoffLock.title': 'Signed off · locked',
  'nexus.sources.addTable': 'Add',
  'nexus.sources.bulkAdd': 'Add selected',
  'nexus.sources.bulkAddFailed': '{count, plural, one {# table could not be added} other {# tables could not be added}}',
  'nexus.sources.bulkAddResult': '{count, plural, one {# table added} other {# tables added}}',
  'nexus.sources.bulkClear': 'Clear',
  'nexus.sources.bulkSelected': '{count, plural, one {# table selected} other {# tables selected}}',
  'nexus.sources.catalogUnavailable': 'Live catalog unavailable — showing tables already in this mapping.',
  'nexus.sources.col.source': 'Source',
  'nexus.sources.col.status': 'Status',
  'nexus.sources.col.table': 'Table',
  'nexus.sources.detailColField': 'Field',
  'nexus.sources.detailColKey': 'Key',
  'nexus.sources.detailColType': 'Type',
  'nexus.sources.detailEmpty': 'Select a source to inspect its fields and add it to the mapping',
  'nexus.sources.detailFields': '{count} fields',
  'nexus.sources.detailNoFields': 'No fields available for this table.',
  'nexus.sources.detailNotAdded': 'Add this table to the mapping to inspect its fields and sample its data.',
  'nexus.sources.empty': 'No matching sources',
  'nexus.sources.error': 'Source catalog unavailable (no data connector).',
  'nexus.sources.filter.any': 'Any',
  'nexus.sources.filter.hidden': 'Hidden',
  'nexus.sources.filter.notAdded': 'Not added',
  'nexus.sources.filter.onCanvas': 'On canvas',
  'nexus.sources.loading': 'Loading catalogs...',
  'nexus.sources.placeTable': 'Place',
  'nexus.sources.remeasure': 'Re-measure column stats & example values',
  'nexus.sources.remeasureFailed': 'Re-measure failed — the source data may not be queryable',
  'nexus.sources.remeasureResult': 'Re-measured {count, plural, one {# column} other {# columns}}',
  'nexus.sources.removeFromView': 'Remove from view',
  'nexus.sources.searchPlaceholder': 'Search all sources...',
  'nexus.sources.selectAll': 'Select all',
  'nexus.sources.selectRow': 'Select {name}',
  'nexus.sources.state.hidden': 'hidden',
  'nexus.sources.state.onCanvas': 'on canvas',
  'nexus.sources.upload.button': 'Upload',
  'nexus.sources.upload.description': 'Each file becomes a source table in this blueprint — no Foundry setup needed.',
  'nexus.sources.upload.dropzone': 'Click to choose files',
  'nexus.sources.upload.remove': 'Remove file',
  'nexus.sources.upload.submit': '{count, plural, =0 {Upload} one {Upload # file} other {Upload # files}}',
  'nexus.sources.upload.systemLabel': 'Source system',
  'nexus.sources.upload.title': 'Upload data files',
  'nexus.sources.upload.toastFailed': 'Upload failed: {names}',
  'nexus.sources.upload.toastSuccess': 'Uploaded {count, plural, one {# table} other {# tables}}',
  'nexus.sources.upload.unsupported': 'Skipped unsupported file(s): {names}',
  'nexus.tableNode.filteredBadge': 'filtered',
  'nexus.tableNode.filteredTooltip': 'Row-level extraction scope filter',
  'nexus.toast.blueprintUpdated': 'Mapping details updated.',
  'nexus.toast.failedUpdateBlueprint': 'Failed to update mapping details.',
  'nexus.versions.currentTag': 'Current',
  'nexus.versions.dialogSubtitle': 'Every published version of this blueprint, newest first.',
  'nexus.versions.dialogTitle': 'Version history',
  'nexus.versions.diff.edges': '{added} added · {removed} removed',
  'nexus.versions.diff.empty': 'No changes since the current version.',
  'nexus.versions.diff.kind.added': 'added',
  'nexus.versions.diff.kind.modified': 'modified',
  'nexus.versions.diff.kind.removed': 'removed',
  'nexus.versions.diff.section.mappings': 'Field mappings',
  'nexus.versions.diff.section.relationships': 'Relationships',
  'nexus.versions.diff.section.sources': 'Sources',
  'nexus.versions.diff.summary': '{count, plural, one {# unsaved change} other {# unsaved changes}} not yet snapshotted — Save to create the next version.',
  'nexus.versions.diff.title': 'Changes since v{version}',
  'nexus.versions.diff.titleGeneric': 'Unsaved changes',
  'nexus.versions.empty': 'No versions published yet.',
  'nexus.versions.history': 'History',
  'nexus.versions.loadError': 'Couldn’t load versions.',
  'nexus.versions.loading': 'Loading versions…',
  'nexus.versions.noSummary': 'No summary',
  'nexus.versions.publish': 'Publish',
  'nexus.versions.publishDescription': 'Snapshot the current blueprint as an immutable version you can restore later.',
  'nexus.versions.publishError': 'Failed to publish version.',
  'nexus.versions.publishSuccess': 'Version published.',
  'nexus.versions.publishTitle': 'Publish version',
  'nexus.versions.restore': 'Restore',
  'nexus.versions.restoreBody': 'This replaces the live blueprint with version {version} and clears any open proposals. A new version is recorded.',
  'nexus.versions.restoreError': 'Failed to restore version.',
  'nexus.versions.restoreSuccess': 'Blueprint restored.',
  'nexus.versions.restoreTitle': 'Restore this version?',
  'nexus.versions.save': 'Save',
  'nexus.versions.saveDescription': 'Snapshot the current blueprint as the next version. Add an optional summary of what changed.',
  'nexus.versions.saveTitle': 'Save changes as a new version',
  'nexus.versions.signoffHistoryViewAll': 'View sign-off history',
  'nexus.versions.summaryLabel': 'What changed? (optional)',
  'nexus.versions.summaryPlaceholder': 'e.g. Accepted the GL account mappings',
  'nexus.versions.title': 'Versions',
  'nexus.versions.viewAll': 'View all {count} versions',
  'nexus.visibility.private': 'Private',
  'nexus.visibility.public': 'Public',
  'nexus.visibility.shared': 'Shared',
  'nexus.workbench.aiLabel': 'AI',
  'nexus.workbench.aiReasoning': 'AI Reasoning',
  'nexus.workbench.button.cancel': 'Cancel',
  'nexus.workbench.button.close': 'Close',
  'nexus.workbench.button.createMapping': 'Create Mapping',
  'nexus.workbench.button.delete': 'Delete',
  'nexus.workbench.button.export': 'Export',
  'nexus.workbench.button.newMapping': 'New Mapping',
  'nexus.workbench.button.run': 'Run',
  'nexus.workbench.button.saveChanges': 'Save Changes',
  'nexus.workbench.button.suggest': 'Suggest',
  'nexus.workbench.button.testSql': 'Test SQL',
  'nexus.workbench.button.validate': 'Validate',
  'nexus.workbench.confirmDeleteMapping.body': 'This will permanently remove the field mapping. This action cannot be undone.',
  'nexus.workbench.confirmDeleteMapping.title': 'Delete this mapping?',
  'nexus.workbench.console.sqlError': 'SQL error: {error}',
  'nexus.workbench.console.sqlValid': 'SQL valid — {rows}',
  'nexus.workbench.console.sqlValidationFailed': 'SQL validation request failed',
  'nexus.workbench.emptyState.noFields': 'No fields',
  'nexus.workbench.explore.refineIfBelow': 'Refine if below',
  'nexus.workbench.explore.sampleSize': 'Sample size',
  'nexus.workbench.inlineMappingsCount': '{count, plural, one {{count} mapping} other {{count} mappings}}',
  'nexus.workbench.kbDocsCount': '{count, plural, one {{count} doc} other {{count} docs}}',
  'nexus.workbench.mappingForm.addField': '+ Add Field',
  'nexus.workbench.mappingForm.addTargetPart': 'Add another target part…',
  'nexus.workbench.mappingForm.caseAddBranch': 'Add branch',
  'nexus.workbench.mappingForm.caseColumn': 'Column',
  'nexus.workbench.mappingForm.caseDefault': 'Else (default)',
  'nexus.workbench.mappingForm.caseDefaultPlaceholder': 'e.g. Unknown',
  'nexus.workbench.mappingForm.caseThen': 'Then',
  'nexus.workbench.mappingForm.caseValue': 'Value (comma-separated for IN)',
  'nexus.workbench.mappingForm.directSingleSource': 'Direct mappings use a single source — switch to Concatenation or Calculated to combine fields.',
  'nexus.workbench.mappingForm.function': 'Function',
  'nexus.workbench.mappingForm.lookupAddPair': 'Add value pair',
  'nexus.workbench.mappingForm.lookupDefault': 'Default (unmatched)',
  'nexus.workbench.mappingForm.lookupDefaultPlaceholder': 'e.g. UNKNOWN (blank = pass through)',
  'nexus.workbench.mappingForm.lookupNullUnmatched': 'Emit NULL for unmatched values',
  'nexus.workbench.mappingForm.lookupSourceValue': 'Source value',
  'nexus.workbench.mappingForm.lookupTargetValue': 'Target value',
  'nexus.workbench.mappingForm.noTransform': 'No transform for this type — the source is copied to the target as-is.',
  'nexus.workbench.mappingForm.selectTarget': 'Select target...',
  'nexus.workbench.mappingForm.separator': 'Separator',
  'nexus.workbench.mappingForm.separatorPlaceholder': 'e.g. - or ,',
  'nexus.workbench.mappingForm.singleSource': 'This transform uses a single source field.',
  'nexus.workbench.mappingForm.sourceFields': 'Source Fields',
  'nexus.workbench.mappingForm.splitHint': 'Split breaks one source into delimited parts; set each target’s part number (defaults to order).',
  'nexus.workbench.mappingForm.splitPartLabel': 'Part index',
  'nexus.workbench.mappingForm.targetField': 'Target Field',
  'nexus.workbench.mappingForm.targetParts': 'Target fields (parts)',
  'nexus.workbench.mappingForm.transform': 'Transform',
  'nexus.workbench.mappingForm.type': 'Type',
  'nexus.workbench.moreCount': '+{count} more',
  'nexus.workbench.proposedCount': 'Proposed ({count})',
  'nexus.workbench.sampleSizeCapWarning': 'Exceeds the limit — will be capped at {max, number} rows',
  'nexus.workbench.sampleSizeCustom': 'Custom…',
  'nexus.workbench.sampleSizeCustomPlaceholder': 'Number of rows',
  'nexus.workbench.sampleSizeMaxHint': 'Max {max, number} rows',
  'nexus.workbench.sampleSizeRows': '{count} rows',
  'nexus.workbench.toast.addedToBlueprint': 'Added {name} to mapping',
  'nexus.workbench.toast.addedToCanvas': 'Added {name} to canvas',
  'nexus.workbench.toast.aiRefined': 'AI refined the mapping',
  'nexus.workbench.toast.aiRefinementFailed': 'AI refinement failed',
  'nexus.workbench.toast.aiSuggestionApplied': 'AI suggestion applied',
  'nexus.workbench.toast.aiSuggestionFailed': 'AI suggestion failed',
  'nexus.workbench.toast.autoValidationFailed': 'Auto-validation failed',
  'nexus.workbench.toast.autoValidationRequestFailed': 'Auto-validation request failed',
  'nexus.workbench.toast.blueprintCreated': 'Mapping created',
  'nexus.workbench.toast.blueprintDeleted': 'Deleted "{name}"',
  'nexus.workbench.toast.blueprintRenamed': 'Mapping renamed',
  'nexus.workbench.toast.duplicateSourceTarget': 'A mapping with these source and target fields already exists',
  'nexus.workbench.toast.failedAddTable': 'Failed to add table',
  'nexus.workbench.toast.failedCreateBlueprint': 'Failed to create mapping',
  'nexus.workbench.toast.failedCreateMapping': 'Failed to create mapping',
  'nexus.workbench.toast.failedDeleteBlueprint': 'Failed to delete mapping',
  'nexus.workbench.toast.failedDeleteMapping': 'Failed to delete mapping',
  'nexus.workbench.toast.failedRenameBlueprint': 'Failed to rename mapping',
  'nexus.workbench.toast.failedUpdateMapping': 'Failed to update mapping',
  'nexus.workbench.toast.invalidSourceOrTarget': 'Invalid source or target field',
  'nexus.workbench.toast.mappingDeleted': 'Mapping deleted',
  'nexus.workbench.toast.mappingProposed': 'Mapping proposed — accept it in the reviewer to apply',
  'nexus.workbench.toast.mappingsPartialFailure': 'Only {created} of {total} mappings were proposed — some parts failed. Please retry.',
  'nexus.workbench.toast.mappingsProposedCount': '{count} mappings proposed — accept them in the reviewer to apply',
  'nexus.workbench.toast.mappingUpdated': 'Mapping updated',
  'nexus.workbench.toast.matchRate': '{rate}% match ({overlap}/{total} source values found in target)',
  'nexus.workbench.toast.queryFailed': 'Query failed',
  'nexus.workbench.toast.refiningMapping': 'Match rate below {threshold}% — asking AI to refine...',
  'nexus.workbench.validate.autoAfterSuggest': 'Auto-validate after suggest',
  'nexus.workbench.validate.autoAfterSuggestDescription': 'Run validation automatically after AI generates a mapping',
  'nexus.workbench.validate.settingsTitle': 'Validate settings',
  'nexus.workbench.validationFailed': 'Validation failed: {error}',
  'nexus.workbench.validationRequestFailed': 'Validation request failed',
  'notFound.cta': 'Go to Home',
  'notFound.description': 'The page you are looking for does not exist.',
  'notFound.title': 'Page not found',
  'notifications.banner.dismiss': 'Dismiss banner',
  'notifications.bell.label': 'Notifications',
  'notifications.card.archive': 'Archive notification',
  'notifications.card.delete': 'Delete notification',
  'notifications.card.dismiss': 'Dismiss notification',
  'notifications.card.goTo': 'Go to notification',
  'notifications.card.markUnread': 'Mark as unread',
  'notifications.desktopPrompt.blocked': 'Desktop notifications are blocked',
  'notifications.desktopPrompt.blockedHint': 'Enable them for this site in your browser settings.',
  'notifications.desktopPrompt.body': 'Get notified on your desktop when something finishes, even when Tessera is in another tab.',
  'notifications.desktopPrompt.dismiss': 'Dismiss',
  'notifications.desktopPrompt.enable': 'Enable',
  'notifications.desktopPrompt.enabled': 'Desktop notifications enabled',
  'notifications.modal.acknowledge': 'Acknowledge',
  'notifications.modal.title': 'Notification',
  'notifications.overlay.clearAll': 'Clear all',
  'notifications.overlay.more': '{count, plural, one {# more notification} other {# more notifications}}',
  'notifications.panel.description': 'List of your notifications.',
  'notifications.panel.domain.chat': 'Chat',
  'notifications.panel.domain.codeRemediation': 'Code Remediation',
  'notifications.panel.domain.dataFoundry': 'Data Foundry',
  'notifications.panel.domain.dataHarmonization': 'Data Harmonization',
  'notifications.panel.domain.editor': 'Editor',
  'notifications.panel.domain.global': 'Global',
  'notifications.panel.domain.knowledgeBase': 'Knowledge Base',
  'notifications.panel.domain.migrationAssessment': 'Integration Converters',
  'notifications.panel.domain.nexus': 'Nexus',
  'notifications.panel.domain.projects': 'Projects',
  'notifications.panel.domain.skills': 'Skills',
  'notifications.panel.domain.viewRemediation': 'View Remediation',
  'notifications.panel.domain.workflows': 'Workflows',
  'notifications.panel.empty.description': 'New notifications will appear here when something needs your attention.',
  'notifications.panel.empty.title': "You're all caught up",
  'notifications.panel.emptyFiltered.clearFilters': 'Clear filters',
  'notifications.panel.emptyFiltered.description': '{count, plural, one {# unread notification is} other {# unread notifications are}} hidden by your current filters.',
  'notifications.panel.emptyFiltered.title': 'No notifications match your filters',
  'notifications.panel.error.title': 'Failed to load notifications',
  'notifications.panel.filters.autoReadInfo': 'Auto-read info notifications',
  'notifications.panel.filters.autoReadInfoHint': 'Info-level notifications are marked read automatically.',
  'notifications.panel.filters.button': 'Filters',
  'notifications.panel.filters.clearAll': 'Clear all',
  'notifications.panel.filters.close': 'Close filters',
  'notifications.panel.filters.periodLabel': 'Period',
  'notifications.panel.filters.title': 'Filters',
  'notifications.panel.group.earlier': 'Earlier',
  'notifications.panel.group.thisWeek': 'Earlier this week',
  'notifications.panel.group.today': 'Today',
  'notifications.panel.group.yesterday': 'Yesterday',
  'notifications.panel.groupBy.domain': 'Domain',
  'notifications.panel.groupBy.label': 'Group by',
  'notifications.panel.groupBy.time': 'Time',
  'notifications.panel.groupBy.urgency': 'Urgency',
  'notifications.panel.markAll': 'Mark all read',
  'notifications.panel.period.all': 'All time',
  'notifications.panel.period.last30': 'Last 30 days',
  'notifications.panel.period.last7': 'Last 7 days',
  'notifications.panel.period.today': 'Today',
  'notifications.panel.priority.critical': 'Critical',
  'notifications.panel.priority.info': 'Information',
  'notifications.panel.priority.warning': 'Warning',
  'notifications.panel.readFilter.all': 'All',
  'notifications.panel.readFilter.label': 'Filter by read state',
  'notifications.panel.readFilter.unread': 'Unread',
  'notifications.panel.tab.archive': 'Archive',
  'notifications.panel.tab.inbox': 'Inbox',
  'notifications.panel.title': 'Notifications',
  'route.adminSettings': 'Roles & Permissions',
  'route.authorizedMcpClients': 'Authorized MCP clients',
  'route.businessDashboard': 'Business Dashboard',
  'route.codeRemediation': 'Code Modernization',
  'route.connectors': 'Connectors',
  'route.conversations': 'Chats',
  'route.dataFoundry': 'Foundry',
  'route.dataHarmonization': 'Harmonization',
  'route.docs': 'Documentation',
  'route.editor': 'Editor',
  'route.go': 'Open notification',
  'route.home': 'Home',
  'route.jobs': 'Background jobs',
  'route.knowledgeBase': 'Knowledge Base',
  'route.llmModels': 'LLM Models',
  'route.loom': 'Workflows',
  'route.migrationAssessment': 'Integration Converters',
  'route.nexus': 'Nexus',
  'route.platformReleases': 'Operations',
  'route.systems': 'Systems',
  'route.usage': 'Usage',
  'route.viewRemediation': 'View Remediation',
  'route.workbench': 'Workbench',
  'route.worklist': 'Worklist',
  'schedule.rrule.frequency.day': '{count, plural, one {day} other {days}}',
  'schedule.rrule.frequency.hour': '{count, plural, one {hour} other {hours}}',
  'schedule.rrule.frequency.minute': '{count, plural, one {minute} other {minutes}}',
  'schedule.rrule.frequency.month': '{count, plural, one {month} other {months}}',
  'schedule.rrule.frequency.week': '{count, plural, one {week} other {weeks}}',
  'schedule.rrule.frequency.year': '{count, plural, one {year} other {years}}',
  'systems.activity.action.credentialCreated': 'Signed in',
  'systems.activity.action.credentialPurged': 'Sign-in removed',
  'systems.activity.action.credentialRevoked': 'Signed out',
  'systems.activity.action.credentialRotated': 'Sign-in updated',
  'systems.activity.action.systemArchived': 'System archived',
  'systems.activity.action.systemPurged': 'System deleted',
  'systems.activity.action.systemRegistered': 'System created',
  'systems.activity.action.systemResolved': 'Connection used',
  'systems.activity.action.systemTested': 'Connection tested',
  'systems.activity.action.systemUpdated': 'Configuration updated',
  'systems.activity.actorTessera': 'Tessera',
  'systems.activity.by': 'by {actor}',
  'systems.activity.empty': 'No activity yet',
  'systems.activity.error': 'Could not load activity.',
  'systems.activity.group.older': 'Older',
  'systems.activity.group.previous30': 'Previous 30 days',
  'systems.activity.group.previous7': 'Previous 7 days',
  'systems.activity.group.today': 'Today',
  'systems.activity.group.yesterday': 'Yesterday',
  'systems.archive': 'Archive system',
  'systems.archive.confirm': 'Archive',
  'systems.archive.description': 'Archive "{name}"? Its toolkits and user sign-ins stop working.',
  'systems.archive.hint': 'Hide it from the list. Its sign-ins stop working.',
  'systems.archive.title': 'Archive this system?',
  'systems.card.testing': 'Testing connection…',
  'systems.configuration.connection': 'Connection',
  'systems.configuration.enabledEndpoints': 'Enabled endpoints',
  'systems.configuration.endpoints': 'Endpoints',
  'systems.configuration.endpointsHint': 'Enable the endpoints this system exposes.',
  'systems.configuration.managedByAdmins': 'Managed by platform admins.',
  'systems.configuration.save': 'Save changes',
  'systems.configuration.test': 'Run tests',
  'systems.configuration.testing': 'Testing connection…',
  'systems.configuration.unsaved': 'Unsaved changes',
  'systems.connect': 'Connect system',
  'systems.dangerZone': 'Danger zone',
  'systems.delete': 'Delete system',
  'systems.delete.confirm': 'Delete permanently',
  'systems.delete.confirmLabel': 'Type {slug} to confirm',
  'systems.delete.description': "This permanently deletes \"{name}\" and everyone's sign-ins. It can't be undone.",
  'systems.delete.hint': 'Permanently remove it and all sign-ins.',
  'systems.delete.title': 'Delete system',
  'systems.drawer.notFound': 'This system no longer exists.',
  'systems.drawer.tab.activity': 'Activity',
  'systems.drawer.tab.configuration': 'Configuration',
  'systems.drawer.tab.overview': 'Overview',
  'systems.empty.description': 'Connect your first system to get started.',
  'systems.empty.description.viewer': 'A platform admin can connect one.',
  'systems.empty.filtered.description': 'Try a different search or clear the filters.',
  'systems.empty.filtered.title': 'No matching systems',
  'systems.empty.title': 'No systems yet',
  'systems.endpoint.errorTitle': 'Connection error',
  'systems.endpoint.failed': 'Failed',
  'systems.endpoint.passed': 'Passed',
  'systems.endpoint.passedMs': 'Passed {ms}ms',
  'systems.endpoint.showFields': 'Show connection details',
  'systems.endpoint.skipped': 'Skipped',
  'systems.error.load': 'Could not load systems.',
  'systems.error.retry': 'Try again',
  'systems.filters.clear': 'Clear filters',
  'systems.filters.connector': 'Connector',
  'systems.filters.failedOnly': 'Connection failed',
  'systems.filters.searchPlaceholder': 'Search systems',
  'systems.filters.truncated': 'Showing the first {count} systems — refine your search to see the rest.',
  'systems.overview.access': 'Your access',
  'systems.overview.accessVia': 'via {method}',
  'systems.overview.adminInvestigating': 'Your system admin is looking into this.',
  'systems.overview.capabilitiesEmpty': 'No endpoints are enabled yet.',
  'systems.overview.capabilitiesHeading': 'What you can do here',
  'systems.overview.connectionFailedHint': "Tessera couldn't reach this system. Run a test to see what's wrong.",
  'systems.overview.docsLink': 'Learn about {connector}',
  'systems.overview.lastUsedAgo': 'last used {ago}',
  'systems.overview.signedIn': 'Signed in',
  'systems.overview.signIn': 'Your sign-in',
  'systems.overview.signInAction': 'Sign in',
  'systems.overview.signInAlert.description': 'Tessera connects as you — sign in so it can act on your behalf.',
  'systems.overview.signInAlert.expiredDescription': 'Sign in again to keep Tessera connected as you.',
  'systems.overview.signInAlert.expiredTitle': 'Your sign-in has expired',
  'systems.overview.signInAlert.title': 'Sign in to use this system',
  'systems.overview.signInExpired': 'Expired {date}',
  'systems.overview.signInExpires': 'Expires {date}',
  'systems.overview.updateSignIn': 'Update sign-in',
  'systems.page.subtitle': 'Connect external systems and manage how Tessera reaches them.',
  'systems.signIn.alert.expired': 'Sign-in expired',
  'systems.signIn.alert.expiring': 'Sign-in expires soon',
  'systems.signIn.cancel': 'Cancel',
  'systems.signIn.cue.none': 'Sign in',
  'systems.signIn.notSignedIn': 'Not signed in',
  'systems.signIn.purpose': 'Tessera uses this sign-in when toolkits access {name} as you.',
  'systems.signIn.signedOut': 'Signed out',
  'systems.signIn.signOut': 'Sign out',
  'systems.signIn.signOutConfirmDescription': 'Toolkits stop acting as you until you sign in again.',
  'systems.signIn.signOutConfirmTitle': 'Sign out of {name}?',
  'systems.signIn.success': 'Signed in',
  'systems.signIn.title': 'Sign in',
  'systems.signIn.unavailable': 'Sign-in status unavailable',
  'systems.signIn.update': 'Update sign-in',
  'systems.signIn.yourAccount': 'Your account',
  'systems.status.diagnose': 'Run a connection test',
  'systems.status.failed': 'Connection failed',
  'systems.test.check.failed': 'Failed',
  'systems.test.check.passed': 'Passed',
  'systems.test.check.skipped': 'Skipped',
  'systems.test.connectionChecks': 'Connection checks',
  'systems.test.failed': 'Test failed',
  'systems.test.passed': 'Test passed',
  'systems.test.ranAgo': 'Ran {ago}',
  'systems.test.requestFailed': 'The test could not run. Try again.',
  'systems.wizard.back': 'Back',
  'systems.wizard.cancel': 'Cancel',
  'systems.wizard.connect': 'Create system',
  'systems.wizard.created': 'System added',
  'systems.wizard.discard.cancel': 'Keep editing',
  'systems.wizard.discard.confirm': 'Discard',
  'systems.wizard.discard.description': 'Your entries will be lost.',
  'systems.wizard.discard.title': 'Discard this system?',
  'systems.wizard.displayName': 'Name',
  'systems.wizard.done.created': 'System added',
  'systems.wizard.done.signInLater': 'You can sign in later',
  'systems.wizard.done.test': 'Test connection',
  'systems.wizard.done.testAgain': 'Test again',
  'systems.wizard.done.testFailed': 'Connection failed',
  'systems.wizard.done.testIdle': 'Connection not tested yet',
  'systems.wizard.done.testing': 'Testing connection…',
  'systems.wizard.done.testPassed': 'Connection verified',
  'systems.wizard.done.title': '{name} was added',
  'systems.wizard.duplicateName': 'A system with this name already exists. Choose a different name.',
  'systems.wizard.openSystem': 'Open system',
  'systems.wizard.protocols': 'Endpoints',
  'systems.wizard.step.category': 'Vendor',
  'systems.wizard.step.category.title': 'Choose a vendor',
  'systems.wizard.step.details': 'Details',
  'systems.wizard.step.type': 'System',
  'systems.wizard.step.type.title': 'Choose a system',
  'systems.wizard.type.subtitle': 'Choose the specific {family} system to connect.',
  'systems.wizard.variantCount': '{count} systems',
} as const;
